import React from "react";

/**
 * This function allows the customization of the rendering of the results
 * @param result
 * @param t
 * @returns {JSX.Element|string}
 */
export function renderResults(result, t) {
    if (result && result.post_type) {
        return (
            <div style={{ padding: "20px 0 0 0" }}>
                <div key={result.id.raw} className={"corner-border"} style={{ padding: "10px 10px 10px 10px" }}>
                    <h4>{t(result.post_type.raw)}</h4>
                    <h3 className={"jh-search-results__result-title"}>
                        <a href={result.url.raw}>{result.title.raw}</a>
                    </h3>
                    {result.meta_description &&
                        <div
                            className={"jh-search-results__result-description"}>{result.meta_description.raw}</div>
                    }
                    {!result.meta_description && result.excerpt &&
                        <div
                            className={"jh-search-results__result-description"}>{result.excerpt.raw}</div>
                    }
                </div>
            </div>
        );
    } else {
        return '';
    }
}


function getFilterValueDisplay(string) {
    return string;
}

export function renderFacets(className,
    label,
    onMoreClick,
    onRemove,
    onSelect,
    options,
    showMore,
    showSearch,
    onSearch,
    searchPlaceholder, t) {
    return (
        <fieldset className={"sui-facet"}>
            <legend className="sui-facet__title">{t(label)}</legend>
            {showSearch && (
                <div className="sui-facet-search">
                    <input
                        className="sui-facet-search__text-input"
                        type="search"
                        placeholder={searchPlaceholder || "Search"}
                        onChange={e => {
                            onSearch(e.target.value);
                        }}
                    />
                </div>
            )}

            <div className="sui-multi-checkbox-facet">
                {options.length < 1 && <div>No matching options</div>}
                {options.map(option => {
                    const checked = option.selected;
                    return (
                        <label
                            key={`${getFilterValueDisplay(option.value)}`}
                            htmlFor={`example_facet_${label}${getFilterValueDisplay(
                                option.value
                            )}`}
                            className="sui-multi-checkbox-facet__option-label"
                        >
                            <div className="sui-multi-checkbox-facet__option-input-wrapper">
                                <input
                                    id={`example_facet_${label}${getFilterValueDisplay(
                                        option.value
                                    )}`}
                                    type="checkbox"
                                    className="sui-multi-checkbox-facet__checkbox"
                                    checked={checked}
                                    onChange={() =>
                                        checked ? onRemove(option.value) : onSelect(option.value)
                                    }
                                />
                                <span className="sui-multi-checkbox-facet__input-text">
                                    {t(option.value)}
                                </span>
                            </div>
                            <span className="sui-multi-checkbox-facet__option-count">
                                {option.count.toLocaleString("en")}
                            </span>
                        </label>
                    );
                })}
            </div>

            {showMore && (
                <button
                    type="button"
                    className="sui-facet-view-more"
                    onClick={onMoreClick}
                    aria-label="Show more options"
                >
                    + More
                </button>
            )}
        </fieldset>
    );
}